<template>
  <div class="body">

    <!-- common -->
    <div class="common-page dark-theme">
      <div class="wrap">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.png" alt="wavve" />
          </a>
        </h1>
      </div>
      <div v-if="profileList" class="tAc">
        <h2>사용자 선택</h2>
        <h3>시청할 프로필을 선택하세요.</h3>
        <div class="user-wrap01">
          <div v-for="(profile, index) in profileList" :key="index" class="user-style">
            <a href="#" @click.prevent="setProfile(profile.profileid)">
              <div class="user-img"><img :src="profile.image | imageUrl" alt=""/></div>
            </a>
            <a href="#" @click.prevent="setProfile(profile.profileid)">
              <strong class="profile-list-name epg-title-line1">{{ profile.profilename }}</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--// common -->
  </div>
</template>

<script>
import { changeProfileProc } from '@/common/utils/login'
import { getUserProfileList } from '@/common/utils/request'
import { imageUrl } from '@/common/filters/url.filter'
import _ from 'lodash'
import { getSanitizeUrl } from '@/common/utils/referer'
export default {
  data () {
    return {
      profileList: [],
      referer: '/index.html'
    }
  },
  filters: {
    imageUrl
  },
  methods: {
    setProfile (profileId) {
      changeProfileProc({ profileId }).then(() => {
        if (this.referer.indexOf('member.wavve.com') > -1) {
          location.replace(decodeURIComponent(this.referer))
        } else if (this.referer === 'http://www.pooq.co.kr/' || decodeURIComponent(this.referer) === 'http://www.pooq.co.kr/') {
          location.href = 'https://www.wavve.com/index.html'
        } else {
          this.$router.replace(getSanitizeUrl(decodeURIComponent(this.referer)))
        }
      })
    }
  },
  created () {
    this.referer = _.get(this.$route, ['query', 'referer'], '/index.html')
    getUserProfileList({ offset: 0, limit: 10, orderby: 'old' }).then(({ data }) => {
      this.profileList = _.get(data, 'list', [])
    })
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
